import Collect from '@/views/atm/collect/index.vue'

export default [
  {
    path: '/atm/collect',
    name: 'Collect',
    component: Collect,
    meta: {
      authRequired: true,
      desc: '단말회수'
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/atm/index.js